const listeners = new Set();

const state = {
  ready: false,
  user: null,
  token: "",
  uid: "",
  profile: null,
  settings: null,
  oneRM: null,
  estimatedOneRM: null,
  clientPlatform: "web",
  pushConfig: null,
  pushPermission: "default",
  pushSubscriptionId: "",
  pushSubscriptionReady: false,
  androidConfig: null,
  notificationCapabilities: null,
  androidBridgeReady: false,
  androidNotificationPermission: "default",
  androidExactAlarmAllowed: null,
  androidExactAlarmSupported: true,
  androidExactAlarmPermissionRequested: false,
  androidDeviceTokenReady: false,
  androidInstallationId: "",
  androidAppVersion: "",
  androidAppBuild: "",
  androidDeviceInfo: null,
  wakeLockActive: false,
  programs: [],
  activeProgram: null,
  programBuilder: null,
  programBuilderBaseline: null,
  programBuilderStage: "list",
  programBuilderDayIndex: 0,
  programTemplateQuery: "",
  workouts: [],
  customExercises: [],
  exerciseNameMap: {},
  activeSession: null,
  activeWorkout: null,
  sessionItemEditOrder: null,
  sessionItemReorderOrder: null,
  sessionPreviousItem: null,
  sessionPreviousByExercise: {},
  workoutDetailsById: {},
  logsMode: "date",
  logsSelectedDate: "",
  logsCalendarMonth: "",
  logsCalendarDatesByMonth: {},
  logsWorkoutsByDate: {},
  logsSelectedExerciseId: "",
  logsSelectedExerciseName: "",
  logsExerciseHistory: {},
  logsDateExpandedWorkoutId: "",
  logsExerciseExpandedWorkoutId: "",
  logsLoadingMonth: "",
  logsLoadingDate: "",
  logsLoadingExercise: "",
  logsLoadingWorkoutId: "",
  homePreview: null,
  analytics: null,
  selectedTab: "home",
  sessionReturnTab: "home",
};

export function getState() {
  return state;
}

function notifyListeners(previousState, changedKeys) {
  if (!Array.isArray(changedKeys) || changedKeys.length <= 0) {
    return;
  }

  const meta = {
    previousState,
    changedKeys,
  };
  listeners.forEach((listener) => listener(state, meta));
}

export function setState(patch) {
  if (!patch || typeof patch !== "object") {
    return;
  }

  const previousState = { ...state };
  Object.assign(state, patch);
  const changedKeys = Object.keys(patch).filter((key) => !Object.is(previousState[key], state[key]));
  notifyListeners(previousState, changedKeys);
}

export function mutateState(mutator, notify = false) {
  if (typeof mutator === "function") {
    const previousState = notify ? { ...state } : null;
    mutator(state);
    if (notify) {
      const changedKeys = Array.from(
        new Set([...Object.keys(previousState || {}), ...Object.keys(state)]),
      ).filter((key) => !Object.is(previousState[key], state[key]));
      notifyListeners(previousState, changedKeys);
    }
  }
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
